import Input from '@/common/components/Input';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React from 'react';

const InputsSK = ({ addressFormInputs, handleChangeInputValue }) => {
	const { translation } = useTranslationContext();

	return (
		<>
			<Input
				margin='6px'
				name={translation.postalCode}
				width={120}
				inputWidth={260}
				value={addressFormInputs.postalCode}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('postalCode', e)}
			/>
			<Input
				margin='6px'
				name={translation.city}
				width={120}
				inputWidth={260}
				value={addressFormInputs.city}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('city', e)}
			/>
			<Input
				margin='6px'
				name={translation.street}
				width={120}
				inputWidth={260}
				value={addressFormInputs.street}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('street', e)}
			/>
			<Input
				margin='6px'
				name={translation.building}
				width={120}
				inputWidth={260}
				value={addressFormInputs.building}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('building', e)}
				requiredSign={true}
			/>
			<Input
				margin='6px'
				name={translation.apartment}
				width={120}
				inputWidth={260}
				value={addressFormInputs.apartment}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('apartment', e)}
			/>
			<Input
				margin='6px'
				name={translation.phone_number_for_courier}
				width={120}
				inputWidth={260}
				value={addressFormInputs.phoneForCourier}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('phoneForCourier', e)}
			/>
			<Input
				margin='6px'
				name={translation.courierInfo}
				width={120}
				inputWidth={260}
				value={addressFormInputs.additionalInfo}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('additionalInfo', e)}
			/>
		</>
	);
};

export default InputsSK;
